import { createRouter, createWebHistory } from 'vue-router'

const primaryRouteNames = ['live', 'calibration', 'history', 'rank', 'settings', 'changelog', 'about'] as const
export type PrimaryRouteName = (typeof primaryRouteNames)[number]

const routeViewLoaders = {
  live: () => import('@/views/LiveView.vue'),
  calibration: () => import('@/views/CalibrationView.vue'),
  history: () => import('@/views/HistoryView.vue'),
  rank: () => import('@/views/RankView.vue'),
  settings: () => import('@/views/SettingsView.vue'),
  changelog: () => import('@/views/ChangelogView.vue'),
  about: () => import('@/views/AboutView.vue'),
} as const

export async function preloadRouteView(name: PrimaryRouteName): Promise<void> {
  await routeViewLoaders[name]()
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'live', component: routeViewLoaders.live },
    { path: '/live', redirect: '/' },
    { path: '/calibration', name: 'calibration', component: routeViewLoaders.calibration },
    { path: '/history', name: 'history', component: routeViewLoaders.history },
    { path: '/history/:id', redirect: '/history' },
    { path: '/sessions', redirect: '/history' },
    { path: '/sessions/:id', redirect: '/history' },
    { path: '/rank', name: 'rank', component: routeViewLoaders.rank },
    { path: '/settings', name: 'settings', component: routeViewLoaders.settings },
    { path: '/changelog', name: 'changelog', component: routeViewLoaders.changelog },
    { path: '/about', name: 'about', component: routeViewLoaders.about },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})
